export enum ShowcaseConstants {
  SET_SHOWCASE_STATUS = 'SET_SHOWCASE_STATUS',
}
